module.exports = __webpack_public_path__ + "static/media/34-12.9fa938ed.mp3";